var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import { ResizeableContainer } from '@stratascratch/ui';
import { Zap, ZapOff, Plus, Minus } from '@stratascratch/icons';
import BaseCodeEditor from './BaseCodeEditor';
import EditorButtons from './EditorButtons';
import useAutocomplete from './useAutocomplete';
import useFontSize from './useFontSize';
import './CodeEditor.css';
const CodeEditor = forwardRef((_a, ref) => {
    var { className, autocomplete, fontSizeChange } = _a, rest = __rest(_a, ["className", "autocomplete", "fontSizeChange"]);
    const { autocompleteEnabled, toggleAutocomplete } = useAutocomplete();
    const { fontSize, setFontSize } = useFontSize();
    const innerRef = useRef(null);
    useImperativeHandle(ref, () => innerRef.current);
    const tooltips = [
        autocompleteEnabled ? 'Disable autocomplete' : 'Enable autocomplete',
        ...(fontSizeChange ? ['Increase font size', 'Decrease font size'] : []),
    ];
    const autocompleteHandler = () => {
        toggleAutocomplete();
        if (innerRef.current) {
            innerRef.current.focus();
        }
    };
    const increaseFontSize = () => {
        if (innerRef.current) {
            innerRef.current.increaseFontSize();
            innerRef.current.focus();
            setFontSize(innerRef.current.getFontSize());
        }
    };
    const decreaseFontSize = () => {
        if (innerRef.current) {
            innerRef.current.decreaseFontSize();
            innerRef.current.focus();
            setFontSize(innerRef.current.getFontSize());
        }
    };
    useEffect(() => {
        if (fontSizeChange && fontSize && innerRef.current) {
            innerRef.current.setFontSize(fontSize);
        }
    });
    return (_jsxs(ResizeableContainer, { className: `CodeEditor__container ${className}`, children: [(autocomplete || fontSizeChange) && (_jsxs(EditorButtons, { tooltips: tooltips, children: [autocomplete && (_jsx("span", { role: "button", tabIndex: 0, onClick: autocompleteHandler, onKeyDown: autocompleteHandler, children: autocompleteEnabled ? _jsx(Zap, {}) : _jsx(ZapOff, {}) })), fontSizeChange && _jsx(Plus, { onClick: increaseFontSize }), fontSizeChange && _jsx(Minus, { onClick: decreaseFontSize })] })), _jsx(BaseCodeEditor, Object.assign({ mode: "pgsql" }, rest, { autocomplete: autocomplete && autocompleteEnabled, ref: innerRef }))] }));
});
export default CodeEditor;
//# sourceMappingURL=CodeEditor.js.map